import { render } from "./Impact_Assessment.vue?vue&type=template&id=4a522311&scoped=true"
import script from "./Impact_Assessment.vue?vue&type=script&lang=js"
export * from "./Impact_Assessment.vue?vue&type=script&lang=js"

import "./Impact_Assessment.vue?vue&type=style&index=0&id=4a522311&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a522311"]])

export default __exports__